import { jsx as _jsx } from "react/jsx-runtime";
import { useNationality } from "@faire/retailer-visitor-shared/hooks/retailer/useNationality";
import { useIsLoggedInRetailerOrBrandPreview } from "@faire/retailer-visitor-shared/lib/isLoggedInRetailer";
import { showProductPromotions } from "@faire/retailer-visitor-shared/lib/showProductPromotions";
import { Price } from "@faire/retailer-visitor-shared/views/product/ProductDetails/Price/Price";
import { PRICE_TEXT_SURFACE } from "@faire/retailer-visitor-shared/views/product/ProductDetails/Price/PriceProps";
import { formatMoney } from "@faire/web--source/common/money";
import React from "react";
/**
 * TODO:@z27fangFaire This component should be eliminated once we have all product tile to be composable tiles.
 */ export var PriceText = function(param) {
    var productTile = param.productTile;
    var _productTile_min_option_wholesale_promo_price;
    var isUK = useNationality().isUK;
    var isLoggedIn = useIsLoggedInRetailerOrBrandPreview();
    if (!productTile) {
        return null;
    }
    var productLevelPromotion = productTile === null || productTile === void 0 ? void 0 : productTile.min_option_wholesale_promo_price;
    var originalPrice = (productTile === null || productTile === void 0 ? void 0 : productTile.min_option_wholesale_price) ? formatMoney({
        money: productTile.min_option_wholesale_price,
        omitCentsIfZero: true
    }) : "";
    var wholesalePrice = (productTile === null || productTile === void 0 ? void 0 : (_productTile_min_option_wholesale_promo_price = productTile.min_option_wholesale_promo_price) === null || _productTile_min_option_wholesale_promo_price === void 0 ? void 0 : _productTile_min_option_wholesale_promo_price.discounted_item_price) ? formatMoney({
        money: productTile.min_option_wholesale_promo_price.discounted_item_price,
        omitCentsIfZero: true
    }) : originalPrice;
    var retailPrice = (productTile === null || productTile === void 0 ? void 0 : productTile.min_option_retail_price) ? formatMoney({
        money: productTile.min_option_retail_price,
        omitCentsIfZero: true
    }) : "";
    return /*#__PURE__*/ _jsx(Price, {
        isUKRetailer: isUK,
        isLoggedInOrBrandPreview: isLoggedIn,
        showProductPromotions: showProductPromotions(productLevelPromotion),
        originalPrice: originalPrice,
        wholesalePrice: wholesalePrice,
        retailPrice: retailPrice,
        small: true,
        isTilePricing: true,
        priceTextSurface: PRICE_TEXT_SURFACE.PRODUCT_TILE
    });
};
